import { render } from "./StartView.vue?vue&type=template&id=c8587c1c&scoped=true"
import script from "./StartView.vue?vue&type=script&lang=js"
export * from "./StartView.vue?vue&type=script&lang=js"

import "./StartView.vue?vue&type=style&index=0&id=c8587c1c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8587c1c"]])

export default __exports__